import { apiRequest } from "../../../services/api";
import { IForgotPassword } from "../type/forgotPasswordType";

export const forgotPassword = async (data: IForgotPassword) => {
  return await apiRequest<IForgotPassword>("POST", "/auth/forgot-password", {
    email: data.email,
  });
};
